import { z } from 'zod'

import { emailSchema } from '@/shared/lib/validation/email'
import { phoneSchema } from '@/shared/lib/validation/phone'

const namePattern = /^([^-][а-яА-Я]*-?[а-яА-Я]*)(\s[^-][а-яА-Я]*-?[а-яА-Я]*)?$/

export const contactSchema = z.object({
	NAME: z
		.string({ required_error: 'Введите имя' })
		.trim()
		.min(2, 'Минимум 2 символа')
		.max(255, 'Максимум 255 символов')
		.regex(namePattern, 'Некорректный формат'),
	PHONE: phoneSchema,
	EMAIL: emailSchema
})

/**
 * Явный тип результата формы: при strictNullChecks: false z.infer/z.output для Zod-схем
 * дают все поля optional и ломают совместимость с `entities/product` API.
 */
export type ContactData = {
	NAME: string
	PHONE: string
	EMAIL: string
}
